import Footer from './containers/Footer/Footer';

export { Footer };
export default Footer;
